import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import { CmsImageForUrl } from 'src/components/images/CmsImageForUrl';
import ChartItemAdmissions from 'src/components/kinotoppen/ChartItemAdmissions';
import ChartItemPremiere from 'src/components/kinotoppen/ChartItemPremiere';
import { MovieChartItem as MovieChartItemType } from 'src/lib/movieinfo/movieinfotypes';
import styles from './MovieChartItem.module.css';

//#region [Props]
type MovieChartItemProps = {
    chartItem: MovieChartItemType;
};
//#endregion

//#region [Component]
export default function MovieChartItem({ chartItem }: MovieChartItemProps) {
    return <FilmwebLink className={styles.SMovieChartItem} to={`/film/${chartItem.movie!.mainVersionId}`}>
        <div className={styles.SChartPosition}>
            {chartItem.pos}
            <div className={styles.SPreviousChartPosition}>{chartItem.posPrev}</div>
        </div>
        <div className={styles.SPoster}>
            {chartItem.movie!.sanityImagePosterUrl && <CmsImageForUrl
                className={styles.SChartPoster}
                imageUrl={chartItem.movie!.sanityImagePosterUrl}
                alt={`Plakat for ${chartItem.movie!.title}`}
                width={100}
                unoptimized
                isPosterAspect />}
        </div>
        <div className={styles.SDetails}>
            <div className={styles.SMovieTitle}>{chartItem.movie!.title}</div>
            <ChartItemPremiere premiere={chartItem.movie?.premiere} />
            <ChartItemAdmissions label="Uker" value={chartItem.weeksOnList} />
            <ChartItemAdmissions label="Besøk" value={chartItem.admissions} />
            <ChartItemAdmissions label="Besøk forrige" value={chartItem.admissionsPrev} />
            <ChartItemAdmissions label="Totalt" value={chartItem.admissionsToDate} />
        </div>
    </FilmwebLink>;
}
//#endregion

//#region [Styles]
//#endregion
